import { ApiProperty } from '@nestjs/swagger';
import { User } from '../../user/entities/user.entity';

export class FileResponseDto {
  @ApiProperty({
    description: 'The unique identifier of the file',
    example: 1
  })
  id: number;

  @ApiProperty({
    description: 'The URL where the file can be accessed',
    example: 'https://example.com/uploads/file.jpg'
  })
  url: string;

  @ApiProperty({
    description: 'The module where the file is used',
    example: 'newsfeed'
  })
  module: string;

  @ApiProperty({
    description: 'The module ID where the file is used',
    example: 1
  })
  module_id: number | null;

  @ApiProperty({
    description: 'The mime type of the file',
    example: 'image/jpeg'
  })
  mime_type: string;

  @ApiProperty({
    description: 'The timestamp when the file was uploaded',
    example: '2025-09-03T10:00:00Z'
  })
  created_at: Date;

  @ApiProperty({
    description: 'The timestamp when the file was last updated',
    example: '2025-09-03T10:00:00Z'
  })
  updated_at: Date;
}
